import React from "react";
import MainLayoutsV2 from "../../layout/MainLayoutsV2";
import HeroSection from "./HeroSection";
import BootcampProgramsSection from "./BootcampProgramsSection";
import TheBootcampExperienceSection from "./TheBootcampExperienceSection";
import ScholarshipSection from "./ScholarshipSection";

import { 
    WhyLearnSection, 
    WhoWeAreSection, 
    TestimonialSection, 
    NewsletterSection 
} from "./AdditionalSections";

export default function LandingPageV2() {
  return (
    <MainLayoutsV2>
      <div className="bg-white font-sans w-full overflow-x-hidden">
        {/* Core Hero */}
        <HeroSection />
        
        {/* Immersive Bootcamp Programs */}
        <BootcampProgramsSection />
        
        {/* The Blueprint to Hiring */}
        <TheBootcampExperienceSection />

        {/* Live Active Cohorts to drive urgency */}
        {/* <ActiveCohortSectionV2 /> */}
        
        {/* Financial Support */}
        <ScholarshipSection />
        
        {/* E1X Advantage / Value Prop */}
        <WhyLearnSection />
        <WhoWeAreSection />
        
        {/* Social Proof */}
        <TestimonialSection />
        
        {/* Newsletter CTA */}
        <NewsletterSection />
      </div>
    </MainLayoutsV2>
  );
}
